<template>
  <iframe
    ref="iframe"
    :src="domain"
    width="100%"
    height="100%"
    frameborder="0"
    allowtransparency
  />
</template>

<script>
export default {
  name: 'LoyaltyFrame',

  props: {
    domain: {
      required: true
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/loyalty/LoyaltyFrame.vue